import { useAppStore } from '@/store/app';
import { useAuthStore } from '@/store/auth';

export function getDefaultRequestHeaders() {
  const appStore = useAppStore();
  const authStore = useAuthStore();

  const headers: Record<string, string> = {};

  headers['ngrok-skip-browser-warning'] = 'true';

  const buildVersion = appStore.info.build;

  if (buildVersion) {
    headers['X-Build-Version'] = buildVersion;
  }

  const appVersion = appStore.info.version;

  if (appVersion) {
    headers['X-App-Version'] = appVersion;
  }

  const appPackage = appStore.info.package;

  if (appPackage) {
    headers['X-App-Package'] = appPackage;
  }

  const platform = appStore.platform;

  if (platform) {
    headers['X-Platform'] = platform;
  }

  const token = authStore.token;

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
}
